import { useCallback } from 'react';

import { useLanguage } from './LanguageContext';

const dictionary = {
  de: {
    placeholder: 'Stelle eine Frage',
    helpPrompt:
      'Verrate mir, was du alles kannst, und schlage mir ein paar Fragen vor.',
    moreOptions: 'Weitere Optionen',
    sendNow: 'Absenden',
    scrollToBottom: 'Nach unten scrollen',
    disclaimer:
      'KI-Antworten sind möglicherweise nicht immer korrekt. Wir empfehlen, Informationen, die Ihnen wichtig sind, zu überprüfen.',
    help: 'Hilfe',
    resetConversation: 'Chat zurücksetzen',
    rateLimitExceeded:
      'Das Nutzungslimit für KI-Anfragen ist vorerst erreicht. Bitte versuchen Sie es später erneut.',
  },
  en: {
    placeholder: 'Ask anything',
    helpPrompt:
      'Tell me what you’re good at, and suggest a few questions I could ask.',
    moreOptions: 'More options',
    sendNow: 'Send now',
    scrollToBottom: 'Scroll to bottom',
    disclaimer:
      'AI responses may not always be accurate. We recommend verifying information that matters to you.',
    help: 'Help',
    resetConversation: 'Reset conversation',
    rateLimitExceeded:
      'The usage limit for AI requests has been reached for now. Please try again later.',
  },
  fr: {
    placeholder: 'Posez une question',
    helpPrompt:
      'Dis-moi ce que tu sais bien faire, et propose-moi quelques questions que je pourrais poser.',
    moreOptions: "Plus d'options",
    sendNow: 'Envoyer',
    scrollToBottom: 'Faire défiler vers le bas',
    disclaimer:
      "Les réponses générées par l'IA ne sont pas toujours exactes. Nous vous recommandons de vérifier les informations importantes pour vous.",
    help: 'Aide',
    resetConversation: 'Réinitialiser le chat',
    rateLimitExceeded:
      "La limite d'utilisation des requêtes IA est atteinte pour le moment. Veuillez réessayer plus tard.",
  },
} as const;

type DictionaryLanguage = keyof typeof dictionary;
type DictionaryKey = keyof (typeof dictionary)[DictionaryLanguage];

export function useTranslate() {
  const language = useLanguage();
  const dictionaryLanguage: DictionaryLanguage =
    language in dictionary ? language : 'en';

  return useCallback(
    function translate(key: DictionaryKey): string {
      return dictionary[dictionaryLanguage][key];
    },
    [dictionaryLanguage],
  );
}
